import { STEPPER_FORM_DATA_KEY } from '../constants/stepperFormDataKey'

export const clearStepperFormData = (): void => sessionStorage.removeItem(STEPPER_FORM_DATA_KEY)
